import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { updateQuery, useMobile } from '@ux/logo-hooks';
import Link from '@ux/link'; // Regex for whitespace and non-typographical unicode characters
// eslint-disable-next-line no-control-regex

var WHITESPACE_REGEX = /[\s\u0000-\u001F\u007F-\u009F]/g;
/**
 * Renders shared GD logo.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} shared logo
 * @public
 */

export default function PLLogo(props) {
  var figClass = props.figClass,
      privateLabelName = props.privateLabelName,
      _props$logos = props.logos,
      logos = _props$logos === void 0 ? {} : _props$logos;
  var url = useMobile(props) ? logos.mobile : logos.desktop;
  var imgSrc = (url || '').replace(WHITESPACE_REGEX, ''); //
  // If no URL for a custom logo has been provided then display
  // the name of the private label.
  //

  if (!imgSrc) {
    return /*#__PURE__*/React.createElement("span", {
      id: "registrar",
      className: "logo-text"
    }, privateLabelName);
  } // To prevent SVGs from rendering 0x0, set an arbitrarily large enough width
  // to cover the max-width of the span. Only appropriate for SVGs because
  // other image types would stretch if their aspect ratio is narrower than
  // the span's.


  var svgHack = /\.svg$/.test(imgSrc) && {
    width: 200
  };
  var logo = /*#__PURE__*/React.createElement("figure", {
    className: classnames('logo-img', figClass)
  }, /*#__PURE__*/React.createElement("img", _extends({
    id: "registrar",
    src: encodeURI(imgSrc),
    alt: privateLabelName
  }, svgHack)));
  return props.href ? /*#__PURE__*/React.createElement(Link, {
    className: classnames(props.className, 'white-logo-bg'),
    urlArgs: props.urlArgs,
    "data-eid": props['data-eid'],
    onClick: props.onClick,
    rel: "nofollow",
    href: updateQuery(props.href, props.urlArgs)
  }, logo) : logo;
}
PLLogo.defaultProps = {
  urlArgs: {}
};
PLLogo.propTypes = {
  /** CSS class name to apply to the outer link */
  'className': PropTypes.string,

  /** use the mobile logo at all breakpoints */
  'collapsedLogo': PropTypes.bool,

  /** Unique id used for Traffic 2 ie: 'your.product.godaddy.preformatted.eid_value.click' */
  'data-eid': PropTypes.string,

  /** href to pass to Link component */
  'href': PropTypes.string,

  /** An object with desktop and mobile logo source links */
  'logos': PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string
  }),

  /** Callback for a click on the logo link */
  'onClick': PropTypes.func,

  /** The reseller's private label name shown under the logo image or when no logos provided */
  'privateLabelName': PropTypes.string.isRequired,

  /** CSS class name to apply to wrapping `figure` element */
  'figClass': PropTypes.string,

  /** An object with arguments being passed to `Link` component to generate correct `href` */
  'urlArgs': PropTypes.object
};